import { FC, useRef } from 'react';

import { AvailableCurrencies, CURRENCY_SYMBOLS } from 'utils/clickme';

import { Banner, BottomSheet, Text, TooltipHover } from '@hh.ru/magritte-ui';
import { QuestionCircleOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import { formatToReactComponent } from 'bloko/common/trl';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

import { useGetPricePerClick } from 'components/CpcFlexibleCreate/CpcForm/AdRegions/PricePerClickLabel/useGetPricePerClick';

import { PriceType, selectCampaignAreas } from 'store/models/createCampaign';
import { useSelector } from 'store/utils';

import styles from 'components/CpcFlexibleCreate/CpcForm/AdRegions/PricePerClickLabel/PricePerClickLabel.module.less';

const TrlKeys = {
    textWithRegions: 'AdCreate.AdForm.LabeledDynamicPricePerClick.withRegions',
    dynamicPrice: 'AdCreate.AdForm.Regions.Price.hint.dynamic',
    fixedPrice: 'AdCreate.AdForm.Regions.Price.hint.fixed',
    textWithoutRegions: 'AdCreate.AdForm.Regions.Price.hint.withoutRegions',
    tooltip: 'AdCreate.AdForm.LabeledDynamicPricePerClick.tooltip',
};

export const PricePerClickLabel: FC = () => {
    const [isShowBottomSheet, setIsShowBottomSheetOn, setIsShowBottomSheetOff] = useOnOffState(false);

    const adRegions = useSelector(selectCampaignAreas);
    const { pricePerClick, priceType } = useGetPricePerClick();

    const trl = useTrls();

    const activatorRef = useRef<HTMLDivElement>(null);

    const contentByPriceType =
        priceType === PriceType.Fixed ? (
            <Text>
                {formatToReactComponent(trl(TrlKeys.fixedPrice), {
                    '[0]': (
                        <>
                            {pricePerClick}
                            {CURRENCY_SYMBOLS[AvailableCurrencies.RUR]}
                        </>
                    ),
                })}
            </Text>
        ) : (
            <div className={styles.wrapper}>
                <Text Element="span">
                    {formatToReactComponent(trl(TrlKeys.dynamicPrice), {
                        '[0]': (
                            <>
                                {pricePerClick}
                                {CURRENCY_SYMBOLS[AvailableCurrencies.RUR]}
                            </>
                        ),
                    })}
                </Text>
                <span className={styles.icon} ref={activatorRef}>
                    <QuestionCircleOutlinedSize16 initialColor="secondary" onClick={setIsShowBottomSheetOn} />
                </span>
                <TooltipHover activatorRef={activatorRef} placement="right-center">
                    <Text>{trl(TrlKeys.tooltip, [pricePerClick])}</Text>
                </TooltipHover>
                <BottomSheet visible={isShowBottomSheet} onClose={setIsShowBottomSheetOff}>
                    <Text>{trl(TrlKeys.tooltip, [pricePerClick])}</Text>
                </BottomSheet>
            </div>
        );

    return (
        <Banner
            style="accent-secondary"
            showClose={false}
            content={adRegions.include.length > 0 ? contentByPriceType : <Text>{trl(TrlKeys.textWithoutRegions)}</Text>}
            stretched
            data-qa="price"
        />
    );
};
